<template>
    <div class="not-found">
        <img src="@/assets/images/404.png" alt="404 Not Found" class="not-found-image" />
        <h1 class="not-found-title">Laweta się odpięła!</h1>
        <p class="not-found-text">
            Wygląda na to, że ta strona pojechała w innym kierunku niż myślałeś...<br />
            Ale spokojnie – zawsze znajdzie się hak, żeby wrócić na trasę!
        </p>
        <router-link to="/" class="not-found-button">Wróć na stronę główną</router-link>
    </div>
</template>

<style scoped lang="scss">
.not-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background-color: $color-background;
    color: $color-text;
    text-align: center;
    min-height: 100vh;
}

.not-found-image {
    max-width: 420px;
    width: 100%;
    margin-bottom: 24px;
}

.not-found-title {
    font-size: 2.2rem;
    font-weight: bold;
    margin-bottom: 12px;
    color: $color-primary-dark;
}

.not-found-text {
    font-size: 1.15rem;
    color: $color-text-light;
    margin-bottom: 24px;
    line-height: 1.6;
}

.not-found-button {
    display: inline-block;
    padding: 12px 28px;
    background-color: $color-primary;
    color: $color-white;
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.2s ease;

    &:hover {
        background-color: $color-primary-dark;
    }
}
</style>